export default {
  namespaced: true,
  pisos: {
    title: "Pisos",
    unit_id: "Instalación",
    name: "Nombre",
    floor_number: "Número de piso",
    headcount: "Capacidad máxima",
    headcount_table: "Ocupación",
    is_occupied: "¿Está ocupado?",
    active_inactive: "Activo/Inactivo",
    active: "Activo",
    inactive: "Inactivo",
    rems: "REMS",
    sirh: "SIRH",
    sector: "Sector",
  },
};